// src/pages/CategoryPage.jsx
import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import products from '../data/products';
import './categoryPage.css';

const CategoryPage = () => {
  const { category } = useParams();
  const [selectedStrain, setSelectedStrain] = useState('all');
  
  const categoryProducts = products.filter(p => p.category === category);
  const strains = ['all', ...new Set(categoryProducts.map(p => p.strain))];
  
  const filteredProducts = selectedStrain === 'all' 
    ? categoryProducts 
    : categoryProducts.filter(p => p.strain === selectedStrain);

  const getCategoryName = (cat) => {
    return cat.replace('-', ' ');
  };

  const getCategoryDescription = (cat) => {
    switch(cat) {
      case 'Flower':
        return 'Premium cannabis flower available in various strains and quantities.';
      case 'Exotic-Flower':
        return 'Top-shelf exotic strains for the discerning connoisseur.';
      case 'Edibles':
        return 'Delicious THC-infused edibles in various forms and potencies.';
      case 'Concentrates':
        return 'High-potency concentrates for experienced users.';
      case 'cart':
        return '510-thread vape cartridges with premium extracts.';
      case 'disposable-cart':
        return 'Convenient disposable vape pens in various strains.';
      case 'Pre-rolls':
        return 'Pre-rolled joints for instant enjoyment.';
      case 'Shake':
        return 'Premium shake at great value.';
      default:
        return '';
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <div className="flex items-center space-x-2 text-gray-600 mb-2">
          <Link to="/categories" className="hover:text-emerald-600">Categories</Link>
          <span>/</span>
          <span className="text-gray-800">{getCategoryName(category)}</span>
        </div>
        
        <div className="flex flex-col md:flex-row md:items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold">{getCategoryName(category)}</h1>
            <p className="text-gray-600 mt-2">{getCategoryDescription(category)}</p>
          </div>
          <div className="mt-4 md:mt-0">
            <Link
              to="/products"
              className="text-emerald-600 hover:text-emerald-700 font-semibold"
            >
              View All Products →
            </Link>
          </div>
        </div>
      </div>

      {/* Strain Filter */}
      {strains.length > 2 && (
        <div className="bg-white rounded-xl shadow-sm p-4 mb-8">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setSelectedStrain('all')}
              className={`px-4 py-2 rounded-full transition-colors duration-300 ${
                selectedStrain === 'all' 
                  ? 'bg-emerald-600 text-white' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              All Strains
            </button>
            {strains
              .filter(strain => strain !== 'all')
              .map(strain => (
                <button
                  key={strain}
                  onClick={() => setSelectedStrain(strain)}
                  className={`px-4 py-2 rounded-full transition-colors duration-300 ${
                    selectedStrain === strain 
                      ? `${
                          strain === 'Sativa' ? 'bg-yellow-500 text-gray-900' :
                          strain === 'Indica' ? 'bg-purple-500 text-white' :
                          'bg-green-500 text-white'
                        }` 
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {strain}
                </button>
              ))}
          </div>
        </div>
      )}

      {/* Results Count */}
      <div className="mb-6">
        <p className="text-gray-600">
          {filteredProducts.length} {filteredProducts.length === 1 ? 'product' : 'products'} 
          {selectedStrain !== 'all' && ` in ${selectedStrain}`}
        </p>
      </div>

      {/* Products Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <div className="text-center py-16">
          <div className="text-6xl mb-4">🌿</div>
          <h2 className="text-2xl font-semibold mb-2">No products in this category</h2>
          <p className="text-gray-600 mb-6">Try selecting a different strain or category</p>
          <div className="space-x-4">
            <button
              onClick={() => setSelectedStrain('all')}
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg transition-colors duration-300 font-semibold"
            >
              Show All Strains
            </button>
            <Link
              to="/categories"
              className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded-lg transition-colors duration-300 font-semibold"
            >
              Browse Categories
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;